export default "__VITE_ASSET__CZW$JaUH__"